;(function( window, document, $, undefined ) {
	'use strict';

	// Intern Banner

	function internBanner() {

    // Add btn Scroll
    function background( $target ) {
      $('.intern-banner').each(function(){
        var $this = $(this);
        var elBackground = $this.css('background-color');

        if( $this.hasClass('bg-color-mobile') ) {
          var newAlpha = 1;
          var bg = elBackground;
          var a = bg.slice(4).split(',');
          var newBg = 'rgba'+a[0]+','+parseInt(a[1])+','+parseInt(a[2])+','+newAlpha+')';
          $this.append( '<div class="intern-banner-bg-solid"></div>' );
          $('.intern-banner-bg-solid').css('backgroundColor', newBg);
        }

        $this.addClass('no-background');
        $this.append( '<div class="intern-banner-bg" style="background-color: ' + elBackground + ';"></div>' );
      });

      function bgPosition() {
        $('.intern-banner-bg').each(function(){
          var $this = $(this);
          var $parent = $this.closest('.intern-banner');
          var $contentStretch = $parent.find('.intern-banner-content');

          var elPositionLeft = $contentStretch.offset().left;
          var elWidth = ($contentStretch.width() + elPositionLeft);

          $this.css({
            width: elWidth
          });
        });
      }

      bgPosition();
      $(window).resize(function(){
        window.setTimeout(function(){
          bgPosition();
        }, 100);
      });
    }

		// Globals
		return {
      background: background
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.internBanner = internBanner();

})( window, document, jQuery );
